'use es6';

export const HUBSPOT = 'HUBSPOT';
export const PORTAL_SPECIFIC = 'PORTAL_SPECIFIC';
export const INTEGRATION = 'INTEGRATION';